<div
  class="required-documents-item-header clearfix"
  (click)="!mustShowAviso ? openReportModal() : showAvisoDocumentacao()"
>
  <div class="required-documents-item-image-wrapper col-xs-2">
    <div class="required-documents-item-check" *ngIf="reportCopy">
      <em class="required-documents-item-check-icon glyphicon glyphicon-ok"></em>

      <span class="required-documents-item-check-badge"></span>
    </div>
  </div>

  <div class="required-documents-item-name col-xs-8">
    {{ document.descPendencia }}
  </div>

  <div class="required-documents-item-icon-wrapper col-xs-2">
    <em class="required-documents-item-icon"></em>
  </div>
</div>

<app-modal
  #modalReport
  [hideButtons]="true"
  [title]="'Termo de Responsabilidade e de vistoria de veículos'"
  [ignoreBackdropClick]="true"
  [hideClose]="true"
>
  <div [ngClass]="{ hide: reportStep !== 1 }">
    <div
      class="data-section"
      *ngIf="
        reportInfo?.vehicleType === 'AUTOMOVEL' && vehicleAccessories?.length
      "
    >
      <div class="data-section-title">Acessórios:</div>

      <div class="row">
        <div class="checklist">
          <label
            class="checklist-item"
            *ngFor="let accessory of vehicleAccessories"
          >
            {{ accessory.descricao }}

            <input
              type="checkbox"
              name="selected"
              [(ngModel)]="accessory.selected"
            />
          </label>
        </div>
      </div>
    </div>

    <div class="data-section" *ngIf="vehicleStates?.length">
      <div class="data-section-title">Resultado do estado geral do bem:</div>

      <div class="row">
        <table class="table table-condensed table-hover" aria-describedby="Listagem Estado do Veículo.">
          <thead>
            <tr>
              <th></th>

              <th class="text-center min-cell-width">Bom</th>

              <th class="text-center min-cell-width">Regular</th>

              <th class="text-center min-cell-width">Ruim</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let state of vehicleStates; index as i">
              <td class="text-left">{{ state.descricao }}</td>

              <td class="text-center">
                <input
                  type="radio"
                  [name]="'state' + i"
                  value="good"
                  [checked]="state.good"
                  (change)="handleChangeState($event, state)"
                />
              </td>

              <td class="text-center">
                <input
                  type="radio"
                  [name]="'state' + i"
                  value="regular"
                  [checked]="state.regular"
                  (change)="handleChangeState($event, state)"
                />
              </td>

              <td class="text-center">
                <input
                  type="radio"
                  [name]="'state' + i"
                  value="bad"
                  [checked]="state.bad"
                  (change)="handleChangeState($event, state)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="form-group"
      *ngIf="reportInfo"
      [ngClass]="{ 'has-error': isRenavamInvalid }"
    >
      <label for="report-form-renavam-input">Renavam</label>

      <input
        type="text"
        id="report-form-renavam-input"
        class="form-control"
        name="renavam"
        [disabled]="
          reportInfo?.vehicleRenavam !== undefined && !incorrectRenavam
        "
        [(ngModel)]="renavam"
        #inputRenavam
        uppercase
        [justNumber]="true"
        maxlength="11"
        (blur)="handleBlurRenavam()"
        [attr.aria-invalid]="isRenavamInvalid"
      />

      <small class="text-danger" *ngIf="isRenavamInvalid"
        >Renavam inválido</small
      >
    </div>

    <div
      class="checkbox"
      *ngIf="reportInfo && reportInfo?.vehicleRenavam !== undefined"
    >
      <label>
        <input
          type="checkbox"
          name="incorrectRenavam"
          [(ngModel)]="incorrectRenavam"
          (change)="handleChangeIncorrectRenavam($event)"
        />

        <span>Ops... Esta informação está incorreta.</span>
      </label>
    </div>

    <div class="modal-btns">
      <button
        type="button"
        class="btn btn-app btn-default"
        (click)="goToBackStep()"
      >
        Fechar
      </button>

      <button
        type="button"
        class="btn btn-app btn-primary"
        (click)="goToStep(2)"
        [disabled]="!isReportDataValid()"
      >
        Continuar
      </button>
    </div>
  </div>

  <div [ngClass]="{ hide: reportStep !== 2 }">
    <div class="data-section">
      <div class="data-section-title">Resumo do laudo</div>

      <div class="info-values" *ngIf="reportInfo">
        <div>
          <span class="info-values-label">Tipo de veículo:</span>
          {{ reportInfo?.vehicleType }}
        </div>

        <div>
          <span class="info-values-label">Marca/Modelo:</span>
          {{ reportInfo?.vehicleBrand }}/{{ reportInfo?.vehicleModel }}
        </div>

        <div>
          <span class="info-values-label">Ano do modelo:</span>
          {{ reportInfo?.vehicleModelYear }}
        </div>

        <div><span class="info-values-label">Renavam:</span> {{ renavam }}</div>
      </div>

      <div class="data-section" *ngIf="reportInfo?.vehicleType === 'AUTOMOVEL'">
        <div class="data-section-subtitle">Acessórios:</div>

        <div class="row">
          <div class="checklist disabled">
            <label
              class="checklist-item"
              *ngFor="let accessory of vehicleAccessories"
            >
              {{ accessory.descricao }}

              <input
                type="checkbox"
                name="selected"
                [checked]="accessory.selected"
                disabled
              />
            </label>
          </div>
        </div>
      </div>

      <div class="data-section">
        <div class="data-section-subtitle">Estado geral do bem:</div>

        <div class="row">
          <table class="table table-condensed disabled" aria-describedby="Listagem de estado do veículo.">
            <thead>
              <tr>
                <th></th>

                <th class="text-center min-cell-width">Bom</th>

                <th class="text-center min-cell-width">Regular</th>

                <th class="text-center min-cell-width">Ruim</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let state of vehicleStates; index as i">
                <td class="text-left">{{ state.descricao }}</td>

                <td class="text-center">
                  <input type="radio" [checked]="state.good" disabled />
                </td>

                <td class="text-center">
                  <input type="radio" [checked]="state.regular" disabled />
                </td>

                <td class="text-center">
                  <input type="radio" [checked]="state.bad" disabled />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="info-values" *ngIf="reportInfo">
        <div>
          <span class="info-values-label">Local da vistoria:</span>
          {{ reportInfo?.reportLocation }}
        </div>

        <div>
          <span class="info-values-label">Vistoriador:</span>
          {{ reportInfo?.surveyorName }}
        </div>

        <div>
          <span class="info-values-label">CPF do vistoriador:</span>
          {{ reportInfo?.surveyorDocument }}
        </div>
      </div>

      <div class="checkbox">
        <label>
          <input type="checkbox" name="confirm" #confirm />

          <span>Confirmo que as informações acima são verdadeiras.</span>
        </label>
      </div>
    </div>

    <div class="modal-btns">
      <button
        type="button"
        class="btn btn-app btn-default"
        (click)="goToBackStep()"
      >
        Voltar
      </button>

      <button
        type="button"
        class="btn btn-app btn-primary"
        (click)="createReport()"
        [disabled]="!confirm.checked"
      >
        Gerar laudo
      </button>
    </div>
  </div>
</app-modal>
